import { render, staticRenderFns } from "./CommisionSales.vue?vue&type=template&id=68f521ec&scoped=true"
import script from "./CommisionSales.vue?vue&type=script&lang=js"
export * from "./CommisionSales.vue?vue&type=script&lang=js"
import style0 from "./CommisionSales.vue?vue&type=style&index=0&id=68f521ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f521ec",
  null
  
)

export default component.exports